import { createStore, applyMiddleware, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

import reducer, { initialState, State } from './reducer';

const enhancers = composeWithDevTools(applyMiddleware(thunk));

let store: Store | null = null;
export function getStore(): Store<State> {
  if (store === null) {
    store = createStore(reducer, initialState, enhancers);
  }

  return store;
}
